/* eslint-disable max-len */
import React from 'react';
import { Box, Typography, CardMedia } from '@mui/material';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import image1 from '../../images/feature1.svg';
import image2 from '../../images/feature2.svg';
import image3 from '../../images/feature3.svg';

const Features = () => (
  <Box
    id="features"
    sx={{
      width: '100%', padding: { xs: '30px 50px', sm: '60px 100px' }, background: '#fff', display: 'flex', flexDirection: 'column', gap: '80px',
    }}
  >
    <Box sx={{
      width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: { xs: 'center', sm: 'space-between' }, gap: { xs: '20px', sm: '0' },
    }}
    >
      <Box sx={{ width: { xs: '100%', sm: '45%' } }}>
        <Typography sx={{ fontWeight: '500', fontSize: '20px', color: '#1A76D2' }}>QUALITY WORK</Typography>
        <Typography sx={{ fontWeight: '700', fontSize: '40px', color: '#243E63' }}>
          A 4-step Process
          <br />
          {' '}
          For
          <span style={{ color: '#1A76D2' }}> Consistent Results</span>
        </Typography>
        <Box sx={{
          display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '10px', margin: '10px 0',
        }}
        >
          <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
          <Typography sx={{
            width: '100%', fontWeight: '300', fontSize: '18px', color: '#ADB5C3',
          }}
          >
            Files are split into small parts and typed by our certified transcribers, captioners & translators
          </Typography>
        </Box>
        <Box sx={{
          display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '10px', margin: '10px 0',
        }}
        >
          <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
          <Typography sx={{
            width: '100%', fontWeight: '300', fontSize: '18px', color: '#ADB5C3',
          }}
          >
            Reviewers check the parts, add speaker tracking and time-codes
          </Typography>
        </Box>
        <Box sx={{
          display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '10px', margin: '10px 0',
        }}
        >
          <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
          <Typography sx={{
            width: '100%', fontWeight: '300', fontSize: '18px', color: '#ADB5C3',
          }}
          >
            Parts are collated and the combined transcript is proofread for consistency and accuracy
          </Typography>
        </Box>
        <Box sx={{
          display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: '10px', margin: '10px 0',
        }}
        >
          <CheckCircleOutlineOutlinedIcon sx={{ color: '#3E8CD9' }} />
          <Typography sx={{
            width: '100%', fontWeight: '300', fontSize: '18px', color: '#ADB5C3',
          }}
          >
            Accuracy is assessed, the file alternates between Proofreading and QC till accuracy is 99% or more
          </Typography>
        </Box>
      </Box>
      <Box sx={{ width: { xs: '100%', sm: '50%' } }}>
        <CardMedia
          component="img"
          width={{ xs: '100%', sm: '50%' }}
          height="100%"
          image={image1}
          alt="hero section"
        />
      </Box>
    </Box>

    <Box sx={{
      width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: { xs: 'center', sm: 'space-between' }, alignItems: 'center', gap: { xs: '20px', sm: '0' },
    }}
    >
      <Box sx={{ width: { xs: '100%', sm: '50%' } }}>
        <CardMedia
          component="img"
          width={{ xs: '100%', sm: '50%' }}
          height="100%"
          image={image2}
          alt="hero section"
        />
      </Box>
      <Box sx={{ width: { xs: '100%', sm: '45%' } }}>
        <Typography sx={{ fontWeight: '500', fontSize: '20px', color: '#1A76D2' }}>IMPROVE YOUR SEO</Typography>
        <Typography sx={{ fontWeight: '700', fontSize: '40px', color: '#243E63' }}>
          Discover Actionable and
          <span style={{ color: '#1A76D2' }}> Shareable Moments.</span>
        </Typography>
        <Typography sx={{
          width: '100%', fontWeight: '300', fontSize: '18px', color: '#ADB5C3',
        }}
        >
          Take minutes to read through and leverage insights from hours of audio.
        </Typography>
      </Box>
    </Box>

    <Box sx={{
      width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: { xs: '20px', sm: '0' },
    }}
    >
      <Box sx={{ width: { xs: '100%', sm: '45%' } }}>
        <Typography sx={{ fontWeight: '500', fontSize: '20px', color: '#1A76D2' }}>ACCESSIBILITY</Typography>
        <Typography sx={{ fontWeight: '700', fontSize: '40px', color: '#243E63' }}>
          Make Your Content
          <span style={{ color: '#1A76D2' }}> Accessible To All.</span>
        </Typography>
        <Typography sx={{
          width: '100%', fontWeight: '300', fontSize: '18px', color: '#ADB5C3',
        }}
        >
          Drive engagement with a wider and more diverse audience. Amplify the impact of your content and reach people in over 12 languages.
        </Typography>
      </Box>
      <Box sx={{ width: { xs: '100%', sm: '50%' } }}>
        <CardMedia
          component="img"
          width={{ xs: '100%', sm: '50%' }}
          height="100%"
          image={image3}
          alt="hero section"
        />
      </Box>
    </Box>
  </Box>
);

export default Features;
